// app/javascript/controllers/draft_card_controller.js
import { Controller } from "@hotwired/stimulus";
import Swal from "sweetalert2";

export default class extends Controller {
    static values = { sgid: String }

    async delete(e) {
        e.preventDefault();

        const confirmed = await Swal.fire({
            title: "Delete this draft?",
            text: "This can’t be undone.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Delete",
            cancelButtonText: "Cancel",
            reverseButtons: true
        }).then(r => r.isConfirmed);

        if (!confirmed) return;

        try {
            const res = await fetch(`/dashboard/drafts/${encodeURIComponent(this.sgidValue)}`, {
                method: "DELETE",
                headers: {
                    "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content || ""
                }
            });

            if (!res.ok) {
                const j = await res.json().catch(() => ({}));
                throw new Error(j.error || "Delete failed");
            }

            await Swal.fire({ icon: "success", title: "Draft deleted", timer: 1200, showConfirmButton: false });
            const url = new URL(window.location.href);
            url.searchParams.set("filters", "drafts");
            window.location.assign(url.toString());
        } catch (err) {
            Swal.fire({ icon: "error", title: "Couldn’t delete draft", text: err.message });
        }
    }
}